var _g, _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMastercard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 19,
    viewBox: "0 0 32 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2484_7735)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.9999 14H14V5H18L17.9999 14Z",
    fill: "#FF5F00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8754 9.5C13.8754 7.74574 14.7062 6.18303 15.9999 5.17595C15.0206 4.41252 13.8094 3.99818 12.5623 4.00001C9.49026 4.00001 7 6.4624 7 9.5C7 12.5376 9.49026 15 12.5623 15C13.8094 15.0018 15.0207 14.5875 16 13.824C14.7064 12.8172 13.8754 11.2544 13.8754 9.5Z",
    fill: "#EB001B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25 9.5C25 12.5376 22.5099 15 19.438 15C18.1908 15.0018 16.9794 14.5875 16 13.824C17.294 12.817 18.1248 11.2544 18.1248 9.5C18.1248 7.74565 17.294 6.18303 16 5.17595C16.9794 4.41255 18.1907 3.99822 19.4379 4.00001C22.5098 4.00001 24.9999 6.4624 24.9999 9.5",
    fill: "#F79E1B"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 18,
    rx: 1.5,
    stroke: "#E8E8E8"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2484_7735"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 11,
    fill: "white",
    transform: "translate(7 4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMastercard);
export default __webpack_public_path__ + "static/media/mastercard.be12b1b7ad7a6ad219d5b88b7ba16444.svg";
export { ForwardRef as ReactComponent };